<template>
    <div class="main-content">
        <div class="background">
            <div class="container">
                <div class="panel pricing-table">
                    
                    <div class="pricing-plan">
                        <img src="../../assets/images/pricing-planes.png" alt="" class="pricing-img">
                        <h2 class="pricing-header">Free</h2>
                        <ul class="pricing-features">
                        <li class="pricing-features-item">Non-Commercial Use</li>
                        </ul>
                        <span class="pricing-price">Free</span>
                        <!-- <router-link to="/soon" class="pricing-button">Install App</router-link> -->
                        <a target='_blank' href="https://play.google.com/store/apps/details?id=com.Ainak.AinakARApp" class="pricing-button">Install App</a>
                    </div>

                    <div class="pricing-plan">
                        <img src="../../assets/images/pricing-plane.png" alt="" class="pricing-img">
                        <h2 class="pricing-header">Pro</h2>
                        <ul class="pricing-features">
                        <li class="pricing-features-item">starting From €99<br>per user/month</li>
                        </ul>
                        <span class="pricing-price">€99</span>
                        <router-link to="/registerpay" class="pricing-button">Sign up</router-link>
                        <!-- <a href="#/" class="pricing-button">Sign up</a> -->
                    </div>
                    
                    <div class="pricing-plan">
                        <img src="../../assets/images/pricing-aeroplane.png" alt="" class="pricing-img">
                        <h2 class="pricing-header">SME</h2>
                        <ul class="pricing-features">
                        <li class="pricing-features-item">starting From €399<br>5+ users/month</li>
                        </ul>
                        <span class="pricing-price">€399</span>
                        <router-link to="/registerpay" class="pricing-button is-featured">Sign up</router-link>
                        <!-- <a href="#/" class="pricing-button is-featured">Sign up</a> -->
                    </div>
                    
                    <div class="pricing-plan">
                        <img src="../../assets/images/pricing-shuttle.png" alt="" class="pricing-img">
                        <h2 class="pricing-header">Enterprise</h2>
                        <ul class="pricing-features">
                        <li class="pricing-features-item">per quotation<br> + Services</li>
                        <!-- <li class="pricing-features-item">Simple horizontal scalability</li> -->
                        </ul>
                        <span class="pricing-price">€999</span>
                        <router-link to="/registerpay" class="pricing-button">Sign up</router-link>
                        <!-- <a href="#/" class="pricing-button">Contact us</a> -->
                    </div>
                
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeContent",
        data() {
            return {
            }
        },
        components: {
        },
        computed: {
            selectTab(){
                return this.$store.getters.getUploadPage;
            }
        },
        methods:{
            tabChanged(event){
                console.log("I am changed!",event);
                this.$store.dispatch('setCurrentTab', event)
            }
        }
    };
</script>

<style lang="scss" scoped>

    @import "@/assets/css/colors.scss";

    %top-padding-width-height {
        width: 100%;
        height: 100%;
        top: 0;
    }
    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .main-content {
        grid-area: home-content;
        background-color: $bg-color;
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "home-content-header" "home-content-models";
        grid-template-rows: 10%  90%;
        grid-template-columns: 1fr;
        overflow: hidden;
    }


.background {
  padding: 0 25px 25px;
//   position: relative;
  width: 100%;
}

// .background::after {
//   content: '';
// //   background: $primary-color;
// //   background: -moz-linear-gradient(top, #60a9ff 0%, #4394f4 100%);
// //   background: -webkit-linear-gradient(top, #60a9ff 0%,#4394f4 100%);
// //   background: linear-gradient(to bottom, #60a9ff 0%,#4394f4 100%);
// //   filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#60a9ff', endColorstr='#4394f4',GradientType=0 );
//   height: 350px;
//   left: 0;
// //   position: absolute;
//   top: 0;
//   width: 100%;
//   z-index: 1;
// }

@media (min-width: 900px) {
  .background {
    padding: 20px 0 25px;
  }
}

.container {
  margin: 0 auto;
  padding: 50px 0 0;
  max-width: 960px;
  width: 100%;
}

.panel {
  background-color: #fff;
  border-radius: 10px;
  padding: 15px 25px;
  position: relative;
  width: 100%;
  overflow: auto;
  max-height: 80vh;
}

.pricing-table {
  box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.08), 0px 20px 31px 3px rgba(0, 0, 0, 0.09), 0px 8px 20px 7px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
}

@media (min-width: 900px) {
  .pricing-table {
    flex-direction: row;
  }
}

.pricing-table * {
  text-align: center;
  text-transform: uppercase;
}

.pricing-plan {
  border-bottom: 1px solid #e1f1ff;
  padding: 15px;
}

.pricing-plan:last-child {
  border-bottom: none;
}

@media (min-width: 900px) {
  .pricing-plan {
    border-bottom: none;
    border-right: 1px solid #e1f1ff;
    flex-basis: 100%;
    padding: 15px 35px;
  }

  .pricing-plan:last-child {
    border-right: none;
  }
}

.pricing-img {
  margin-bottom: 25px;
//   max-width: 100%;
  width: 125px;
  height: 125px;
}

.pricing-header {
  color: $primary-color;
  font-weight: 600;
  letter-spacing: 1px;
}

.pricing-features {
  color: #888;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 50px 0 25px;
}

.pricing-features-item {
  border-top: 1px solid #e1f1ff;
  font-size: 12px;
  line-height: 1.5;
  padding: 15px 0;
}

.pricing-features-item:last-child {
  border-bottom: 1px solid #e1f1ff;
}

.pricing-price {
  color: $primary-color;
  display: block;
  font-size: 32px;
  font-weight: 700;
}

.pricing-button {
  border: 1px solid $primary-color;
  border-radius: 10px;
  color: $primary-color;
  display: inline-block;
  margin: 25px 0;
  padding: 15px 35px;
  text-decoration: none;
  transition: all 150ms ease-in-out;
}

.pricing-button:hover,
.pricing-button:focus {
  background-color: #e1f1ff;
}

.pricing-button.is-featured {
  background-color:$primary-color;
  color: #fff;
}

.pricing-button.is-featured:hover,
.pricing-button.is-featured:active {
  background-color: $primary-color;
}

</style>
